import { URL } from './endpoints'
import { submitToApi } from 'awsApi'

export const ACTIONS = {
    GET_PROFILE: {
        START: 'GET_PROFILE START',
        SUCCESS: 'GET_PROFILE SUCCESS',
        FAILURE: 'GET_PROFILE FAILURE',
    },
    POST_PROFILE: {
        START: 'POST_PROFILE START',
        SUCCESS: 'POST_PROFILE SUCCESS',
        FAILURE: 'POST_PROFILE FAILURE',
    },
    STORE_PROFILE: 'STORE_PROFILE',
    GET_OVERALL_WELLBEING_SCORES: {
        START: 'GET_OVERALL_WELLBEING_SCORES START',
        SUCCESS: 'GET_OVERALL_WELLBEING_SCORES SUCCESS',
        FAILURE: 'GET_OVERALL_WELLBEING_SCORES FAILURE',
    },
}

export const postProfile =
    (body, successCallback = () => {}, errorCallback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_PROFILE.START })
        try {
            const { payload } = await submitToApi({
                body,
                method: 'POST',
                path: URL.USER_PROFILES.V3_USERS_PROFILES_USER_UPDATE,
                url: URL.USER_PROFILES.BASE,
            })
            dispatch({ type: ACTIONS.POST_PROFILE.SUCCESS, data: payload.data })
            successCallback(payload.data)
        } catch (error) {
            dispatch({ type: ACTIONS.POST_PROFILE.FAILURE, error })
            errorCallback(error)
        }
    }

export const getProfile = successCallback => async dispatch => {
    dispatch({ type: ACTIONS.GET_PROFILE.START })
    try {
        const { payload } = await submitToApi({
            path: URL.USER_PROFILES.V3_USERS_PROFILES_USER_RETRIEVE,
            url: URL.USER_PROFILES.BASE,
        })
        localStorage.setItem('userProfile', JSON.stringify(payload.data))
        dispatch({ type: ACTIONS.GET_PROFILE.SUCCESS, data: { userProfile: payload.data } })
        successCallback && successCallback(payload.data)
    } catch (error) {
        dispatch({ type: ACTIONS.GET_PROFILE.FAILURE, data: error })
    }
}

export const storeProfile = profile => dispatch => dispatch({ type: ACTIONS.STORE_PROFILE, data: profile })

export const resetProfileForTests = body => async () => {
    try {
        await submitToApi({
            body,
            method: 'POST',
            path: URL.USER_PROFILES.V3_USERS_PROFILES_USER_RESET,
            url: URL.USER_PROFILES.BASE,
        })
    } catch (error) {
        console.log('resetProfileForTests error', error)
    }
}

export const getOverallWellbeingScoresRequest = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_OVERALL_WELLBEING_SCORES.START })
    try {
        const { payload } = await submitToApi({
            path: URL.USER_PROFILES.V2_USERS_PROFILES_USER_GET_WELLBEING_SCORE,
            url: URL.USER_PROFILES.BASE,
        })
        dispatch({ type: ACTIONS.GET_OVERALL_WELLBEING_SCORES.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_OVERALL_WELLBEING_SCORES.FAILURE, error })
    }
}
